/**
 * Menu Registry Service
 * Allows modules to register their navigation items dynamically
 */
class MenuRegistry {
    constructor() {
        this.menus = new Map();
    }
    /**
     * Register a module's navigation menu
     * @param config Module menu configuration
     */
    registerMenu(config) {
        this.menus.set(config.moduleId, config);
        console.log(`[MenuRegistry] Registered menu for module: ${config.moduleId}`);
    }
    /**
     * Unregister a module's navigation menu
     * @param moduleId Module identifier
     */
    unregisterMenu(moduleId) {
        this.menus.delete(moduleId);
        console.log(`[MenuRegistry] Unregistered menu for module: ${moduleId}`);
    }
    /**
     * Get all registered module menus
     * @returns Array of module menu configurations
     */
    getAllMenus() {
        return Array.from(this.menus.values());
    }
    /**
     * Get a specific module's menu
     * @param moduleId Module identifier
     * @returns Module menu configuration or undefined
     */
    getMenu(moduleId) {
        return this.menus.get(moduleId);
    }
    /**
     * Get submenu items for a module
     * @param moduleId Module identifier
     * @returns Array of submenu items or empty array
     */
    getSubmenu(moduleId) {
        var _a;
        return ((_a = this.menus.get(moduleId)) === null || _a === void 0 ? void 0 : _a.submenu) || [];
    }
    /**
     * Check if a module has registered a menu
     * @param moduleId Module identifier
     * @returns True if module has a registered menu
     */
    hasMenu(moduleId) {
        return this.menus.has(moduleId);
    }
}
// Export singleton instance
export const menuRegistry = new MenuRegistry();
